// extracted by mini-css-extract-plugin
export default {"toc":"waterbody_fishing_patterns_page__toc--Gh26"};